import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Code,
  useColorModeValue,
} from '@chakra-ui/react';

import type { RfqError } from 'api/quote-marketplace';

interface RfqErrorAlertProps {
  error: RfqError | null;
}

const RfqErrorAlert = ({ error }: RfqErrorAlertProps) => {
  const codeBg = useColorModeValue('gray.900', 'gray.800');
  const codeColor = useColorModeValue('gray.100', 'gray.100');

  const hasRawResponse = Boolean(error && error.response);

  return (
    <Alert
      status="error"
      borderRadius="md"
      flexDirection="column"
      alignItems="flex-start"
    >
      <Box display="flex" alignItems="center">
        <AlertIcon />
        <AlertTitle fontWeight="normal">
          <strong>Acturis error: </strong>
          <i>
            {error?.message ||
              'There was an error submitting the quote request. Please try again.'}
          </i>
        </AlertTitle>
      </Box>

      {hasRawResponse && (
        <Code
          display="block"
          whiteSpace="pre-wrap"
          wordBreak="break-word"
          w="100%"
          mt={3}
          p={3}
          borderRadius="md"
          bg={codeBg}
          color={codeColor}
          fontSize="xs"
          maxH="320px"
          overflowY="auto"
        >
          {JSON.stringify(error?.response, null, 2)}
        </Code>
      )}
    </Alert>
  );
};

export default RfqErrorAlert;
